<template>
  <DataTable v-model:filters="filters"
             class="app-datatable"
             :filterButtonProps="{ filter: { class: 'app-dt-filter-btn' } }"
             :value="rows"
             size="small"
             scrollable
             scrollHeight="80vh"
             :rows="rows"
             stateStorage="session">

    <template #empty>{{ mess_vuoto }}</template>
    <template #loading>{{ mess_caricamento }}</template>

    <Column v-for="column of columns"
            :key="column.name"
            :field="column.name"
            :header="column.title">
      <template #sorticon="slotProps">
        <span
          :class="['app-dt-icon', slotProps.sorted ? (slotProps.sortOrder === 1 ? 'pi pi-sort-amount-up-alt' : 'pi pi-sort-amount-down-alt') : 'pi pi-sort-alt']"></span>
      </template>
      <template #filtericon>
        <span class="pi pi-filter app-dt-icon"></span>
      </template>
      <template #body="{ data, index }">
        <template v-if="column.editabile">
          <InputNumber
            v-if="column.formato === 'num_intero'"
            v-model="data[column.name]"
            @update:modelValue="updateRowData(index, column.name, $event)"
            :min="0"
            :max="999999"
            class="w-full"
          />
          <InputText
            v-else
            v-model="data[column.name]"
            @update:modelValue="updateRowData(index, column.name, $event)"
            class="w-full"
          />
        </template>
        <template v-else>
          <template v-if="column.formato === 'data'">
            {{ data[column.name] != '' && data[column.name] != null ? formatDate(data[column.name]) : '' }}
          </template>
          <template v-else-if="column.formato === 'dataora'">
            {{ data[column.name] != '' && data[column.name] != null ? formatDateTime(data[column.name]) : '' }}
          </template>
          <template v-else-if="column.formato === 'ora_esadecimale'">
            {{ formatTimeHexadecimal(data[column.name]) }}
          </template>
          <template v-else-if="column.formato === 'ora'">
            {{ formatTime(data[column.name]) }}
          </template>
          <template v-else-if="column.formato === 'num_intero'">
            {{ formatNumberInt(data[column.name]) }}
          </template>
          <template v-else-if="column.formato === 'num_decimale'">
            {{ formatNumberDecimal(data[column.name]) }}
          </template>
          <template v-else-if="column.formato === 'prezzo'">
            {{ formatCurrency(data[column.name]) }}
          </template>
          <template v-else-if="column.formato === 'colore'">
            <span v-html="formatColor(data[column.name])"></span>
          </template>
          <template v-else-if="column.formato === 'email'">
            <span v-html="formatEmail(data[column.name])"></span>
          </template>
          <template v-else-if="column.formato === 'link'">
            <span v-html="formatLink(data[column.name])"></span>
          </template>
          <template v-else>
            {{ data[column.name] }}
          </template>
        </template>
      </template>
    </Column>
  </DataTable>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';

export default {
  name: "DatatableForm",
  props: [
    'modulo',
    'colonne',
    'route_righe',
    'mess_vuoto',
    'mess_caricamento',
    'route_params',
    'paginator_rows'
  ],
  emits: ['data-updated'],
  components: {
    DataTable,
    Column,
    InputText,
    InputNumber
  },
  data() {
    return {
      filters: [],
      loading: true,
      rows: [],
      columns: this.colonne,
      actions: this.azioni
    }
  },
  async created() {
    try {
      const url = route(this.route_righe, this.route_params);
      const righe = await axios.get(url);
      if (righe.status === 200) {
        this.rows = righe.data;
      } else {
        this.rows = [];
      }
      const columnSums = this.calculateColumnSums();
      this.$emit('data-updated', this.rows, columnSums);
    } catch (error) {
      console.error('Errore nel caricamento dei dati:', error);
      this.rows = [];
      const columnSums = this.calculateColumnSums();
      this.$emit('data-updated', this.rows, columnSums);
    }
  },
  async mounted() {
    this.loading = false;
  },
  methods: {
    updateRowData(rowIndex, fieldName, newValue) {
      if (this.rows[rowIndex]) {
        this.rows[rowIndex][fieldName] = newValue;
        const columnSums = this.calculateColumnSums();
        this.$emit('data-updated', this.rows, columnSums);
      }
    },
    calculateColumnSums() {
      const sums = {};

      const numericEditableColumns = this.columns.filter(column =>
        column.editabile && column.formato === 'num_intero'
      );

      numericEditableColumns.forEach(column => {
        sums[column.name] = this.rows.reduce((sum, row) => {
          const value = parseFloat(row[column.name]) || 0;
          return sum + value;
        }, 0);
      });

      return sums;
    }
  }
}
</script>

<style scoped>
</style>
